<template>
  <header class="main-menu">
    <div class="container">
      <section class="main-menu__logo">
        <a href="https://puertorico.srax.com/" target="_blank" class="logo">
          <img src="../assets/logo.svg">
        </a>
        <a href="https://forms.monday.com/forms/cd7def2b1a93158b25cb8ba9d52646f2?r=use1" target="_blank" class="register">
          Register for 2025
        </a>
      </section>
    </div>
  </header>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/menu.scss';
</style>

<script>

export default {
  name: 'menu',
  data() {
    return {
      
    }
  },
};
</script>